import {Table} from "semantic-ui-react";
import React from "react";

export function CreditNoteLineItems(props) {
    const creditNoteLineItems = props.creditNoteLineItems;

    const listCreditNoteLineItems = creditNoteLineItems.map((lineItem) =>
        <Table.Row key={lineItem.id}>
            <Table.Cell>{lineItem.id}</Table.Cell>
            <Table.Cell>{lineItem.name}</Table.Cell>
            <Table.Cell>{lineItem.ek_netto} €</Table.Cell>
            <Table.Cell>{lineItem.lieferant}</Table.Cell>
            <Table.Cell>{lineItem.kostenstelle}</Table.Cell>
            <Table.Cell>{lineItem.rate}</Table.Cell>
            <Table.Cell>{lineItem.tax_percentage} %</Table.Cell>
            <Table.Cell>{lineItem.quantity}</Table.Cell>
            <Table.Cell>{lineItem.item_total} €</Table.Cell>
        </Table.Row>
    );

    return (
        <Table celled striped>
            <Table.Header>
                <Table.Row>
                    <Table.HeaderCell>ID</Table.HeaderCell>
                    <Table.HeaderCell>Name</Table.HeaderCell>
                    <Table.HeaderCell>EK-netto</Table.HeaderCell>
                    <Table.HeaderCell>Lieferant</Table.HeaderCell>
                    <Table.HeaderCell>Kostenstelle</Table.HeaderCell>
                    <Table.HeaderCell>VK-netto</Table.HeaderCell>
                    <Table.HeaderCell>Steuer</Table.HeaderCell>
                    <Table.HeaderCell>Quantity</Table.HeaderCell>
                    <Table.HeaderCell>VK-netto-gesamt</Table.HeaderCell>

                </Table.Row>
            </Table.Header>
            <Table.Body>{listCreditNoteLineItems}</Table.Body>
        </Table>
    )
}